import {defineStore} from "pinia";
import type PlayerShipDesign from "@/types/PlayerShipDesign.ts";

export const useShipDesignStore = defineStore('shipDesignStore', {
    state: () => ({
        playerShipDesigns: new Map<number, PlayerShipDesign>()
    }),
    getters: {
        getShipDesignById: (state) => (id: number): PlayerShipDesign | undefined => {
            return state.playerShipDesigns.get(id)
        }
    },
    actions: {
        getShipDesignNameById(id: number): string {
            const shipDesign = this.getShipDesignById(id);
            return shipDesign ? shipDesign.name : '';
        },
        setShipDesign(shipDesign: PlayerShipDesign) {
            // Find and cache the frame component code (ends with _frame)
            for (const componentCode of Object.values(shipDesign.components)) {
                if (componentCode.endsWith('_frame')) {
                    shipDesign.frameCode = componentCode
                    break
                }
            }
            this.playerShipDesigns.set(shipDesign.id, shipDesign);
        },
        exportComponentList(id: number): string[] {
            const shipDesign = this.getShipDesignById(id);
            if (!shipDesign) {
                return [];
            }

            // Extract component codes from the design
            const componentCodes: string[] = [];

            // The components property is Record<number, string> where the value is the component code
            for (const componentCode of Object.values(shipDesign.components)) {
                componentCodes.push(componentCode);
            }

            return componentCodes;
        }
    }
})